module.exports = __webpack_public_path__ + "img/success.387db7cc.png";